import { combineReducers } from 'redux';

import { PhoneVerificationAction } from '../types';
import {
  generatePhoneVerificationCodeRequest,
  generatePhoneVerificationCodeSuccess,
  generatePhoneVerificationCodeFail, generatePhoneVerificationClear,
} from '../actions';


const loading = (state = false, action: PhoneVerificationAction) => {
  switch (action.type) {
    case generatePhoneVerificationCodeRequest.type:
      return true;

    case generatePhoneVerificationCodeSuccess.type:
    case generatePhoneVerificationCodeFail.type:
      return false;

    default:
      return state;
  }
};

// const error = (state: string | null = null, action: PasswordRecoveryAction) => {
//   switch (action.type) {
//     case passwordRecoveryRequest.type:
//     case passwordRecoverySuccess.type:
//     case passwordResetRequest.type:
//     case passwordResetSuccess.type:
//     case resetForm.type:
//     case resetChanged.type:
//       return null;
//
//     case passwordRecoveryFail.type:
//     case passwordResetFail.type:
//       return action.payload.message;
//
//     default:
//       return state;
//   }
// };

const generated = (state = false, action: PhoneVerificationAction) => {
  switch (action.type) {
    case generatePhoneVerificationCodeSuccess.type:
      return true;

    case generatePhoneVerificationCodeRequest.type:
    case generatePhoneVerificationCodeFail.type:
    case generatePhoneVerificationClear.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers({
  loading,
  generated,
});
